// Hard-coded tier preview percentages used by MembershipBoostSwitcher.
// Display-only — the real boosts come from the API via ExtraPackage.values[].
export const MEMBERSHIP_BOOST_TIERS = [
  { id: 'free', tier: 0, percentage: 0 },
  { id: 'starter', tier: 1, percentage: 50 },
  { id: 'hobbyist', tier: 2, percentage: 100 },
  { id: 'pro', tier: 3, percentage: 150 },
] as const
